import styled from "styled-components";
import {Segmented} from "antd";

export const StyledSegmented = styled<any>(Segmented)`
    .ant-segmented-item {
        font-weight: 600 !important;
        border-radius: 14px !important;
    }
`